import {Modal} from "react-bootstrap";
import {ImSpinner9} from "react-icons/im";
import React from "react";

export default function SpinnerModal({show,message,color}) {
    return (
        <Modal show={show} size={"sm"} centered>
            <Modal.Body style={{textAlign: "center"}}>
                <div className={"spinner-body"}>
                    <p><strong>{message}</strong></p>
                    <ImSpinner9 className={"loader"} style={{color:color ? color : "black"}}/>
                </div>
            </Modal.Body>
        </Modal>
    )
}
